@if(seatCounts(); as seatCounts) {
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Accelerator</th>
		<th>Offered</th>
		<th>Accepted</th>
	</tr>
	@for(count of seatCounts; track count.accName) {
	<tr>
		<td>{{count.accName}}</td>
		<td>{{count.offered}}</td>
		<td>{{count.accepted}}</td>
	</tr>
	}
</table>
}